export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10599.456a5fe9.jpg";